import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  Button,
  Spinner,
  Alert,
  AlertIcon,
  Checkbox,
  CheckboxGroup,
  Stack,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { getToken } from "utils/auth";
import config from "config";

const EditIndividual = () => {
  const { individual_id } = useParams();
  const toast = useToast();
  const history = useHistory()
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [individual, setIndividual] = useState({
    individual_code: '',
    status: "Unknown",
    sex: "Unknown",
    year_of_birth: null,
    month_of_birth: null,
    day_of_birth: null,
    kinship: "",
    family_code: "",
    family_history: "Unknown",
    consanguinity: "Unknown",
    geographical_origin: "Unknown",

    medical_data: {
      age_at_onset_months: null,
      age_at_onset_years: null,
      age_at_diagnosis_months: null,
      age_at_diagnosis_years: null,
      age_at_study_months: null,
      age_at_study_years: null,
      year_of_blood_sampling: null,
      month_of_blood_sampling: null,
      day_of_blood_sampling: null,
      year_of_dna_extraction: null,
      month_of_dna_extraction: null,
      day_of_dna_extraction: null,
    },
    genetic_data: {
      xp_group: "Unknown",
      exon: "",
      gene_sequencing: "",
      genotype: "",
      mutation_c: "",
      mutation_p: "",
      ngs: "TGS",
      remarks: "",
    },
  });

  const [otherGeo1, setOtherGeo1] = useState("");
  const [otherGeo2, setOtherGeo2] = useState("");

  const [geo1, setGeo1] = useState("Unknown");
  const [geo2, setGeo2] = useState("Unknown");

  const [enableSecondGeo, setEnableSecondGeo] = useState(false);


  const [otherKinship, setOtherKinship] = useState("");

  const statusOptions = ["Healthy", "Patient", "Unknown"];
  const yesNoUnknown = ["Yes", "No", "Unknown"];
  const kinshipOptions = [
    "Affected Sib",
    "Father",
    "Mother",
    "Brother",
    "Sister",
    "Paternal Grandfather",
    "Maternal Grandfather",
    "Paternal Grandmother",
    "Maternal Grandmother",
    "Uncle",
    "Cousin",
    "Other",
  ];
  const [geoOptions, setGeoOptions] = useState([]);
  const xpGroupOptions = ["XPA", "XPB", "XPC", "XPD", "XPE", "XPF", "XPG", "XPV", "Unknown"];
  
  const formBgColor = useColorModeValue("white", "gray.700");
  const formShadowColor = useColorModeValue("md", "dark-lg");
  const textColor = useColorModeValue("teal.500", "teal.300");
  const inputBgColor = useColorModeValue("gray.100", "gray.600");
  const inputTextColor = useColorModeValue("black", "white");
  const buttonColor = useColorModeValue("teal", "teal.400");
  useEffect(() => {
    const fetchIndividual = async () => {
      const token = getToken()
      try {
        const response = await axios.get(`${config.API_URL}/individual/${individual_id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = response.data;
        setIndividual(data);

        const geoResponse = await axios.get(`${config.API_URL}/individuals/geo`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log(geoResponse)
        
        const filteredGeoData = geoResponse?.data?.filter(item => item);
        setGeoOptions(filteredGeoData)


        if(data.geographical_origin.includes("|")){
          setEnableSecondGeo(true)
          setGeo1(data.geographical_origin.split("|")[0])
          setGeo2(data.geographical_origin.split("|")[1])
        }
        else
        {
          setGeo1(data.geographical_origin.split("|")[0])
        }
        
        // Check if kinship is not in predefined options and set it as "Other"
        if (!kinshipOptions.includes(data.kinship) && data.kinship !== "Other") {
          setOtherKinship(data.kinship); // Set the kinship value as 'Other' and store it in the otherKinship input
          setIndividual((prev) => ({
            ...prev,
            kinship: "Other", // Change kinship to "Other"
          }));
        } else {
          setOtherKinship(""); // Reset otherKinship if it's a predefined kinship
        }
        console.log(data);
      } catch (err) {
        setError("Failed to fetch individual data.");
      } finally {
        setLoading(false);
      }
    };

    fetchIndividual();
  }, [individual_id]);


  const handleChange = (section, key, value) => {
    if (section) {
      setIndividual((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [key]: value,
        },
      }));
    } else {
      setIndividual((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const rawXpGroup = individual.genetic_data.xp_group || "";
    const updatedXpGroup = rawXpGroup.toLowerCase().includes("unknown") ? "Unknown" : rawXpGroup;

    let fg1 = geo1
    let fg2 = geo2
    if(enableSecondGeo){
      if(geo1 === "Other")
        fg1 = otherGeo1
      if(geo2 === "Other")
        fg2 = otherGeo2
    }
    else{
      if(geo1 === "Other")
        fg1 = otherGeo1
      fg2 = null
    }

    
    

    if (fg1 === "Unknown" && fg2) {
      [fg1, fg2] = [fg2, fg1];
    }
    if (fg1 === fg2){
      final_geographical_origin = fg1
    }

    let final_geographical_origin = fg1 ? (fg2 ? fg1 + "|" + fg2 : fg1) : "Unknown"
    

    console.log(final_geographical_origin)

    try {

      const token = getToken()
      await axios.put(`${config.API_URL}/individual/edit`, {
        ...individual,
        kinship: updatedKinship,
        geographical_origin : final_geographical_origin,
        genetic_data: { ...individual.genetic_data, xp_group: updatedXpGroup },
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast({
        title: "Individual updated.",
        description: "The individual's details have been successfully updated.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      history.push("/txd/individuals/info/" + individual.individual_code)
    } catch (err) {
      toast({
        title: "Error updating individual.",
        description: "There was an error updating the individual's details. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" color="teal.500" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Flex>
    );
  }

  return (
    <Flex direction="column" >
      <Box p={6} bg="white" shadow="md" borderRadius="lg" backgroundColor={formBgColor}>
        <Heading size="lg" mb={6} color="teal.500">
          Edit Individual: {individual.individual_code}
        </Heading>
        <form onSubmit={handleSubmit}>
          {/* General Information */}
          <FormControl mb={4}>
            <FormLabel>Status</FormLabel>
            <Select
              value={individual.status}
              onChange={(e) => handleChange(null, "status", e.target.value)}
            >
              {statusOptions.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Sex</FormLabel>
            <Select
              value={individual.sex}
              onChange={(e) => handleChange(null, "sex", e.target.value)}
            >
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="Unknown">Unknown</option>
            </Select>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Date of Birth</FormLabel>
            <Flex gap={4}>
              {/* Year of Birth */}
              <Select
                flex="1"
                value={individual.year_of_birth || ""}
                onChange={(e) => handleChange(null, "year_of_birth", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Year</option>
                {[...Array(125)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Select>

              {/* Month of Birth */}
              <Select
                flex="1"
                value={individual.month_of_birth || ""}
                onChange={(e) => handleChange(null, "month_of_birth", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </Select>

              {/* Day of Birth */}
              <Select
                flex="1"
                value={individual.day_of_birth || ""}
                onChange={(e) => handleChange(null, "day_of_birth", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </Flex>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Kinship</FormLabel>
            <Select
              value={individual.kinship}
              onChange={(e) => handleChange(null, "kinship", e.target.value)}
            >
              {kinshipOptions.map((kinship) => (
                <option key={kinship} value={kinship}>
                  {kinship}
                </option>
              ))}
            </Select>
            {individual.kinship === "Other" && (
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}
                mt={2}
                placeholder="Specify kinship"
                value={otherKinship}
                onChange={(e) => setOtherKinship(e.target.value)}
              />
            )}
          </FormControl>

          {/* Family Information */}
          <Heading size="md" mt={6} mb={4}>
            Family Information
          </Heading>
          <FormControl mb={4}>
            <FormLabel>Consanguinity</FormLabel>
            <Select
              value={individual.family.consanguinity}
              onChange={(e) => handleChange("family", "consanguinity", e.target.value)}
            >
              {yesNoUnknown.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mb={4}>
            <FormLabel>Family History</FormLabel>
            <Select
              value={individual.family.family_history}
              onChange={(e) => handleChange("family", "family_history", e.target.value)}
            >
              {yesNoUnknown.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Select>
          </FormControl>

          <Heading size="md" mt={6} mb={4}>
            Geographical Origin
          </Heading>

          <FormControl mb={4}>
            <FormLabel>Primary Geographical Origin</FormLabel>
            <Select
              value={geo1 || "Unknown"}
              onChange={(e) => setGeo1(e.target.value)}
            >
              <option key="Unknown" value="Unknown">
                Unknown
              </option>
              {geoOptions.map((geo) => (
                <option key={geo} value={geo}>
                  {geo}
                </option>
              ))}
              <option key="Other" value="Other">
                Other
              </option>
            </Select>
            {geo1 === "Other" && (
              <Input
                mt={2}
                placeholder="Specify geographical origin"
                value={otherGeo1}
                onChange={(e) => setOtherGeo1(e.target.value)}
              />
            )}
          </FormControl>

          <FormControl mb={4}>
            <Checkbox
              isChecked={enableSecondGeo}
              onChange={(e) => setEnableSecondGeo(e.target.checked)}
            >
              Add Secondary Geographical Origin
            </Checkbox>
            {enableSecondGeo && (
              <>
                <Select
                  mt={2}
                  value={geo2 || "Unknown"}
                  onChange={(e) => setGeo2(e.target.value)}
                >
                  <option key="Unknown" value="Unknown">
                    Unknown
                  </option>
                  {geoOptions.map((geo) => (
                    <option key={geo} value={geo}>
                      {geo}
                    </option>
                  ))}
                  <option key="Other" value="Other">
                      Other
                  </option>
                </Select>
                {geo2 === "Other" && (
                  <Input
                    mt={2}
                    placeholder="Specify secondary geographical origin"
                    value={otherGeo2}
                    onChange={(e) => setOtherGeo2(e.target.value)}
                  />
                )}
              </>
            )}
          </FormControl>

          {/* Medical Data */}
          <Heading size="md" mt={6} mb={4}>
            Medical Data
          </Heading>

          {/* Age at Onset */}
          <Flex mb={4} direction="row" gap={4}>
            <FormControl>
              <FormLabel>Age at Onset (Months)</FormLabel>
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}

                type="number"
                placeholder="Enter age at onset in months"
                value={individual.medical_data.age_at_onset_months ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_onset_months",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Age at Onset (Years)</FormLabel>
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}

                type="number"
                placeholder="Enter age at onset in years"
                value={individual.medical_data.age_at_onset_years ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_onset_years",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
          </Flex>

          {/* Age at Diagnosis */}
          <Flex mb={4} direction="row" gap={4}>
            <FormControl>
              <FormLabel>Age at Diagnosis (Months)</FormLabel>
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}

                type="number"
                placeholder="Enter age at diagnosis in months"
                value={individual.medical_data.age_at_diagnosis_months ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_diagnosis_months",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Age at Diagnosis (Years)</FormLabel>
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}

                type="number"
                placeholder="Enter age at diagnosis in years"
                value={individual.medical_data.age_at_diagnosis_years ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_diagnosis_years",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
          </Flex>

          {/* Age at Study */}
          <Flex mb={4} direction="row" gap={4}>
            <FormControl>
              <FormLabel>Age at Study (Months)</FormLabel>
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}

                type="number"
                placeholder="Enter age at study in months"
                value={individual.medical_data.age_at_study_months ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_study_months",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Age at Study (Years)</FormLabel>
              <Input
                textColor={inputTextColor} backgroundColor={inputBgColor}

                type="number"
                placeholder="Enter age at study in years"
                value={individual.medical_data.age_at_study_years ?? ""}
                onChange={(e) =>
                  handleChange(
                    "medical_data",
                    "age_at_study_years",
                    e.target.value === "" ? null : parseInt(e.target.value, null)
                  )
                }
              />
            </FormControl>
          </Flex>

          <FormControl mb={4}>
            <FormLabel>Date of Blood Sampling</FormLabel>
            <Flex gap={4}>
              {/* Year of Blood Sampling */}
              <Select
                flex="1"
                value={individual.medical_data.year_of_blood_sampling || ""}
                onChange={(e) => handleChange("medical_data", "year_of_blood_sampling", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Year</option>
                {[...Array(125)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Select>

              {/* Month of Blood Sampling */}
              <Select
                flex="1"
                value={individual.medical_data.month_of_blood_sampling || ""}
                onChange={(e) => handleChange("medical_data", "month_of_blood_sampling", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </option>
                ))}
              </Select>

              {/* Day of Blood Sampling */}
              <Select
                flex="1"
                value={individual.medical_data.day_of_blood_sampling || ""}
                onChange={(e) => handleChange("medical_data", "day_of_blood_sampling", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </Flex>
          </FormControl>


          <FormControl mb={4}>
            <FormLabel>Date of DNA Extraction</FormLabel>
            <Flex gap={4}>
              {/* Year of DNA Extraction */}
              <Select
                flex="1"
                value={individual.medical_data.year_of_dna_extraction || ""}
                onChange={(e) => handleChange("medical_data", "year_of_dna_extraction", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Year</option>
                {[...Array(125)].map((_, index) => {
                  const year = new Date().getFullYear() - index;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Select>

              {/* Month of DNA Extraction */}
              <Select
                flex="1"
                value={individual.medical_data.month_of_dna_extraction || ""}
                onChange={(e) => handleChange("medical_data", "month_of_dna_extraction", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", { month: "long" })}
                  </option>
                ))}
              </Select>

              {/* Day of DNA Extraction */}
              <Select
                flex="1"
                value={individual.medical_data.day_of_dna_extraction || ""}
                onChange={(e) => handleChange("medical_data", "day_of_dna_extraction", e.target.value ? parseInt(e.target.value, null) : null)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </Select>
            </Flex>
          </FormControl>


          {/* Genetic Data */}
          {/* Genetic Data */}
          <Heading size="md" mt={6} mb={4}>Genetic Data</Heading>

          <FormControl mb={4}>
            <FormLabel>XP Group</FormLabel>
            <CheckboxGroup
              colorScheme="teal"
              value={
                individual.genetic_data.xp_group.toLowerCase().includes("unknown")
                  ? ["Unknown"]
                  : individual.genetic_data.xp_group.split("|")
              }
              onChange={(values) => {
                let selected = values;
                const wasUnknown = individual.genetic_data.xp_group.toLowerCase().includes("unknown");
                if (values.includes("Unknown")) {
                  if (!wasUnknown) {
                    selected = ["Unknown"];
                  } else if (values.length > 1) {
                    selected = values.filter((v) => v !== "Unknown");
                  }
                }
                const result = selected.includes("Unknown") || selected.length === 0 ? "Unknown" : selected.join("|");
                handleChange("genetic_data", "xp_group", result);
              }}
            >
              <Stack direction="column">
                {xpGroupOptions.map((group) => (
                  <Checkbox key={group} value={group}>
                    {group}
                  </Checkbox>
                ))}
              </Stack>
            </CheckboxGroup>
            
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Gene Sequencing</FormLabel>
            <Textarea
              placeholder="Enter gene sequencing details"
              value={individual.genetic_data.gene_sequencing || ""}
              onChange={(e) =>
                handleChange("genetic_data", "gene_sequencing", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Exon</FormLabel>
            <Input
              textColor={inputTextColor} backgroundColor={inputBgColor}

              placeholder="Enter exon details"
              value={individual.genetic_data.exon || ""}
              onChange={(e) =>
                handleChange("genetic_data", "exon", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Mutation (C)</FormLabel>
            <Input
              textColor={inputTextColor} backgroundColor={inputBgColor}

              placeholder="Enter mutation (C)"
              value={individual.genetic_data.mutation_c || ""}
              onChange={(e) =>
                handleChange("genetic_data", "mutation_c", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Mutation (P)</FormLabel>
            <Input
              textColor={inputTextColor} backgroundColor={inputBgColor}

              placeholder="Enter mutation (P)"
              value={individual.genetic_data.mutation_p || ""}
              onChange={(e) =>
                handleChange("genetic_data", "mutation_p", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Genotype</FormLabel>
            <Input
              textColor={inputTextColor} backgroundColor={inputBgColor}

              placeholder="Enter genotype"
              value={individual.genetic_data.genotype || ""}
              onChange={(e) =>
                handleChange("genetic_data", "genotype", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>NGS</FormLabel>
            <Input
              textColor={inputTextColor} backgroundColor={inputBgColor}

              placeholder="Enter NGS data"
              value={individual.genetic_data.ngs || ""}
              onChange={(e) =>
                handleChange("genetic_data", "ngs", e.target.value || null)
              }
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Remarks</FormLabel>
            <Textarea
              placeholder="Enter any additional remarks"
              value={individual.genetic_data.remarks || ""}
              onChange={(e) =>
                handleChange("genetic_data", "remarks", e.target.value || null)
              }
            />
          </FormControl>



          <Button mt={6} colorScheme="teal" type="submit" backgroundColor={buttonColor}>
            Save Changes
          </Button>
        </form>
      </Box>
    </Flex>
  );
};

export default EditIndividual;
